import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase/app'
import PathNotFound from '../views/pathNotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    name: 'Login',
    path: '/login',
    component: () => import('../views/login.vue')
  },
  {
    name: 'SignInWithToken',
    path: '/signInWithToken',
    component: () => import('../views/signInWithToken.vue')
  },
  {
    name: 'Home',
    path: '/',
    component: () => import('../views/home.vue'),
  },
  {
    name: 'Feature',
    path: '/feature',
    component: () => import('../views/feature.vue'),
  },
  {
    name: 'Package',
    path: '/package',
    component: () => import('../views/package.vue'),
  },
  {
    name: 'Contact',
    path: '/contact',
    component: () => import('../views/contact.vue'),
  },
  {
    name: 'Register',
    path: '/register',
    component: () => import('../views/register.vue'),
  },
  {
    name: 'Forgotpassword',
    path: '/forgot-password',
    component: () => import('../views/forgotPassword.vue'),
  },
  {
    name: 'SelectCompany',
    path: '/companies-list',
    component: () => import('../views/company/list.vue'),
    meta: { requiresAuth: true }
  },
  {
    name: 'AddCompany',
    path: '/company-add',
    component: () => import('../views/company/add.vue'),
    meta: { requiresAuth: true }
  },
  {
    name: 'AddCompanyWithRegisterCode',
    path: '/company-add-with-code',
    component: () => import('../views/company/add-with-register-code.vue'),
    meta: { requiresAuth: true }
  },
  {
    name: 'TaxInfoNeeded',
    path: '/tax-info-needed/:linkId',
    component: () => import('../views/tax-info-needed.vue'),
  },
  {
    name: 'Company',
    path: '/:companyId',
    component: () => import('../views/company/index.vue'),
    children: [
      {
        name: 'Company.Dashboard',
        path: 'dashboard',
        component: () => import('../views/company/dashboard.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Documents',
        path: 'documents',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.DocumentsSaleOnline',
        path: 'documents-sale',
        component: () => import('../views/company/documents.saleorders.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.DocumentsRDB',
        path: 'documents-rdb',
        component: () => import('../views/company/documents.rdb.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.DocumentsPurchase',
        path: 'documents-purchase',
        component: () => import('../views/company/documents.purchase.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.TX',
        path: 'documents-tx',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.DR',
        path: 'documents-dr',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.CR',
        path: 'documents-cr',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.RE',
        path: 'documents-re',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.AB',
        path: 'documents-ab',
        component: () => import('../views/company/documents.abb.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.RT',
        path: 'documents-rt',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.CL',
        path: 'documents-cl',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.Invoice',
        path: 'documents/invoice',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings',
        path: 'settings',
        component: () => import('../views/company/settings.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Settings.Board',
        path: 'settings/board',
        component: () => import('../views/company/setting-board.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Users',
        path: 'settings/users',
        component: () => import('../views/company/setting-users.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Email',
        path: 'settings/email',
        component: () => import('../views/company/setting-email.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Exchange',
        path: 'settings/exchange',
        component: () => import('../views/company/setting-exchange.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.ExchangeRepair',
        path: 'settings/exchange-repair',
        component: () => import('../views/company/setting-exchange-repair.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.AutoDoc',
        path: 'autodoc',
        component: () => import('../views/company/setting-auto-doc.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.ApAutomation',
        path: 'settings/ap-automation',
        component: () => import('../views/company/setting-ap.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.ApAutomationMaster',
        path: 'settings/ap-automation-master',
        component: () => import('../views/company/setting-ap-master.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.ApAutomationPrompt',
        path: 'settings/ap-automation-prompt',
        component: () => import('../views/company/setting-ap-prompt.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.ApAutomationPromptStudent',
        path: 'settings/ap-automation-prompt-student',
        component: () => import('../views/company/setting-ap-prompt-student.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Packages',
        path: 'settings/packages',
        component: () => import('../views/company/setting-packages.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Payments',
        path: 'settings/payments',
        component: () => import('../views/company/setting-payments.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Keys',
        path: 'settings/keys',
        component: () => import('../views/company/setting-keys.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Erp',
        path: 'settings/erp',
        component: () => import('../views/company/setting-erp.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Company',
        path: 'settings/company',
        component: () => import('../views/company/setting-company.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.CompanyDetail',
        path: 'settings/company/:companyDetailId',
        component: () => import('../views/company/setting-company-detail.vue'),
        meta: { requiresAuth: true }
      },

      {
        name: 'Company.Settings.Shops.Add',
        path: 'settings/shops/add',
        component: () => import('../views/company/shop/shop.add.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Shops',
        path: 'settings/shops/:shopId?',
        component: () => import('../views/company/shop/shop.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Shops.Channels',
        path: 'settings/shops/:shopId/channels/:channelId',
        component: () => import('../views/company/shop/shop.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Shops.Edit',
        path: 'settings/shops/:shopId/edit',
        component: () => import('../views/company/shop/shop.edit.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Branch',
        path: 'settings/branch',
        component: () => import('../views/company/setting-branch.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Wht',
        path: 'settings/wht',
        component: () => import('../views/company/setting-wht.vue'),
        meta: { requiresAuth: true }
      },
      {
      name: 'Company.Settings.TestDoc',
      path: 'settings/testdoc',
      component: () => import('../views/company/setting-testdoc.vue'),
      meta: { requiresAuth: true },
      },
      {
      name: 'Company.Settings.TestDoc-AP',
      path: 'settings/testdoc-ap',
      component: () => import('../views/company/setting-testdoc-ap.vue'),
      meta: { requiresAuth: true },
      },
      {
        name: 'Company.Settings.KBank',
        path: 'settings/kbank',
        component: () => import('@/views/company/setting-kbank.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.API',
        path: 'settings/api',
        component: () => import('@/views/company/setting-api.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Profile',
        path: 'profile',
        component: () => import('../views/profile.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Downloaded',
        path: 'downloaded',
        component: () => import('../views/company/downloaded.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Report',
        path: 'report',
        component: () => import('../views/company/report.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.SelectPackage',
        path: 'package',
        component: () => import('../views/company/select.package.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.BuyCertification',
        path: 'buy-certification',
        component: () => import('../views/company/buy.certification.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Payment',
        path: 'payment',
        component: () => import('../views/company/payment.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.reportDocumentAI',
        path: 'reportDocumentAI',
        component: () => import('../views/company/reportDocumentAI.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.DocumentPOAI',
        path: 'documentpoai',
        component: () => import('../views/company/documentPOAI.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.DocumentPOAIVendor',
        path: 'DocumentPOAIVendor/:vendorId',
        component: () => import('../views/company/documentPOAI.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.DocumentSOAI',
        path: 'documentsoai',
        component: () => import('../views/company/documentSOAI.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.DocumentSOAIVendor',
        path: 'DocumentSOAIVendor/:vendorId',
        component: () => import('../views/company/documentSOAI.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.ExchangeRate',
        path: 'exchangerate',
        component: () => import('../views/company/exchangeRate.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.ExchangeHistory',
        path: 'exchangehistory',
        component: () => import('../views/company/exchangeRateHistory.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.DocumentTOPSERV',
        path: 'documentTopserv',
        component: () => import('../views/company/documentTOPSERV.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.DocumentTOPSERVBranch',
        path: 'DocumentTOPSERV/:endsWith',
        component: () => import('../views/company/documentTOPSERV.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.WithholdingTax',
        path: 'reportnetsuitethaitax-withholdingtax',
        component: () => import('../views/company/documents.withholdingTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.ReportNetsuiteThaiTax',
        path: 'reportnetsuitethaitax',
        component: () => import('../views/company/reportNetsuiteThaiTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.WithholdingIncomTax',
        path: 'reportnetsuitethaitax-withholdingIncomTax',
        component: () => import('../views/company/withholdingIncomTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.WithholdingIncomTax.Cancel',
        path: 'reportnetsuitethaitax-withholdingIncomTax-cancel',
        component: () => import('../views/company/documents.withholdingTax.vue'),
        meta: { requiresAuth: true }
      },
      // ภาษี มูลค่าเพี่ม
      {
        name: 'Company.ReportThaiTax',
        path: 'ReportThaiTax',
        component: () => import('../views/company/ReportThaiTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.TaxSales',
        path: 'ReportThaiTax-taxSales',
        component: () => import('../views/company/documents.valueAddedTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.TaxBuy',
        path: 'ReportThaiTax-taxBuy',
        component: () => import('../views/company/documents.valueAddedTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.TaxBuyAverage',
        path: 'ReportThaiTax-taxBuyAverage',
        component: () => import('../views/company/documents.valueAddedTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.taxSupplementaryReport',
        path: 'ReportThaiTax-taxSupplementaryReport',
        component: () => import('../views/company/taxSupplementaryReport.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.TaxReport',
        path: 'ReportThaiTax-taxReport',
        component: () => import('../views/company/taxReport.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.CancelValueAddedTax',
        path: 'ReportThaiTax-CancelTax',
        component: () => import('../views/company/documents.valueAddedTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayable',
        path: 'accountspayable',
        component: () => import('../views/company/documents.accountspayable.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableStudent',
        path: 'accountspayablestudent',
        component: () => import('../views/company/documents.accountspayable.student.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableAnalytics',
        path: 'acctsanalytics',
        component: () => import('../views/company/documents.acctsanalytics.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableTaxReport',
        path: 'acctstaxreport',
        component: () => import('../views/company/documents.acctstaxreport.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.DispCompanies',
        path: 'settings/dispcompanies',
        component: () => import('../views/company/setting-display-companies.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.FixedAsset',
        path: 'fixed-asset',
        component: () => import('../views/company/fixedAsset.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.FixedAssetsList',
        path: 'fixed-asset-count',
        component: () => import('../views/company/fixedAssetsList.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.FixedAssetCount',
        path: 'session-count',
        component: () => import('../views/company/fixedAssetsCount.vue'),
        meta: { requiresAuth: true }
      },
       // end ภาษี มูลค่าเพี่ม
      { path: '/:pathMatch(.*)*', component: PathNotFound },
    ],
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser
  // console.log('##############')
  // console.log('requiresAuth', requiresAuth)
  // console.log('currentUser', currentUser)
  // console.log('to', to)
  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})


export default router
